import React from "react";
//i18n
import { withNamespaces } from "react-i18next";
import { Container } from "reactstrap";
// Redux
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
//Import Breadcrumb
import Breadcrumb_2Items from "../../../../components/Common/Breadcrumb_2Items";
import EquipmentOrders  from "../../../../components/Orders/Equipments/EquipmentOrders";

const EquipmentAllOrders = (props) => {


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            alternateTitle={props.t("Equipments")}
            title={props.t("Orders")}
            breadcrumbItem1={props.t("Equipments")}
            breadcrumbItem2={props.t("All Orders")}
          />
        <EquipmentOrders 
        />
        </Container>
      </div>
     
    
    </React.Fragment>
  );
};

export default withRouter(connect(null, {})(withNamespaces()(EquipmentAllOrders)));
